export const workPositionType = [
  { id: 'DYNAMIC', label: 'Dynamické plánování' },
  { id: 'STATIC', label: 'Statické plánování' }
];



// WEBPACK FOOTER //
// ./src/modules/hr-workPositions/_workPositionsEnum.ts